var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#3CD38F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6128 36.278L31.4677 49.1329C42.1144 46.2938 50.0008 36.5935 50.0008 25.0004C50.0008 24.7638 50.0008 24.5272 50.0008 24.2906L39.9062 14.9846L18.6128 36.278Z",
    fill: "#00BC7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6313 30.599C26.7354 31.7031 26.7354 33.5958 25.6313 34.6999L23.3442 36.987C22.2401 38.0911 20.3474 38.0911 19.2433 36.987L9.22749 26.8924C8.12339 25.7883 8.12339 23.8955 9.22749 22.7914L11.5146 20.5043C12.6187 19.4002 14.5114 19.4002 15.6155 20.5043L25.6313 30.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.386 13.1684C35.4901 12.0643 37.3828 12.0643 38.4869 13.1684L40.774 15.4555C41.8781 16.5596 41.8781 18.4523 40.774 19.5564L23.4238 36.8277C22.3197 37.9318 20.427 37.9318 19.3229 36.8277L17.0358 34.5406C15.9317 33.4365 15.9317 31.5438 17.0358 30.4397L34.386 13.1684Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked1);
export default __webpack_public_path__ + "static/media/checked 1.ed441c15651a30e5a403a3d96c518167.svg";
export { ForwardRef as ReactComponent };